import React from 'react';
import { Box, Center, Heading, Text, useColorModeValue, VStack } from '@chakra-ui/react';
import { useTranslation } from 'react-i18next';
import { useNavigate } from 'react-router-dom';

import { ArcButton } from '../../../../../common/components/ArcButton';
import { SlidingAnimationPageBase } from '../../../../../common/components/SlidingAnimationPageBase';
import { COMPONENT_MIN_HEIGHT, TOP_NAV_SPACING_AFFORDANCE } from '../../../../../common/constants';
import { DeleteAccountIcon, OutlineGradientIcon } from '../../../../../styles/custom-icons';

export function DeleteAccountStart() {
  const navigate = useNavigate();
  const redIconColor = useColorModeValue('#FF3E24', '#FF5B44');
  const { t } = useTranslation();

  return (
    <SlidingAnimationPageBase px={4} title={t('Account.delete account')} backURL={`../../../privacy?direction=back`}>
      <Box display="flex" flexDirection="column" h={`calc(${COMPONENT_MIN_HEIGHT} - ${TOP_NAV_SPACING_AFFORDANCE})`}>
        <Center pt={4} pb={2}>
          <Box position="relative" w="48vw" h="48vw">
            <OutlineGradientIcon w="100%" h="100%" color={redIconColor} data-testid="outline-icon" />
            <DeleteAccountIcon
              position="absolute"
              top="50%"
              left="50%"
              transform="translate(-50%, -50%)"
              w="87px"
              h="74px"
              color={redIconColor}
              data-testid="delete-account-icon"
            />
          </Box>
        </Center>

        <VStack align="stretch" spacing={2} mb={2}>
          <Heading fontSize={24} fontWeight={600} textAlign="center" data-testid="delete-account-title">
            {t('Account.delete account')}
          </Heading>
        </VStack>

        <VStack align="stretch" spacing={2}>
          <Text textAlign="center">{t('Account.deleting your account will')}</Text>
          <Text textAlign="center">
            {t('Account.you will not be able to create a new account')} {t('Account.your energy data is also deleted')}
          </Text>
        </VStack>

        <Center mt="auto" mb={5} flexDir={'column'}>
          <ArcButton
            arcColor={redIconColor}
            w="100%"
            py={6}
            mt="auto"
            onClick={() => navigate('../request-data-archive')}
            data-testid="continue-button"
          >
            {t('Common.continue')}
          </ArcButton>
        </Center>
      </Box>
    </SlidingAnimationPageBase>
  );
}
